import { render, staticRenderFns } from "./Arrange.vue?vue&type=template&id=c56b421c&"
import script from "./Arrange.vue?vue&type=script&lang=js&"
export * from "./Arrange.vue?vue&type=script&lang=js&"
import style0 from "./Arrange.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports